import React, {FC} from "react";
import {FeAvailability} from "../availibilities/redux/types";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import Typography from "@material-ui/core/Typography";
import {format} from "date-fns";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineDot from "@material-ui/lab/TimelineDot";
import {EditOutlined, PlayArrow} from "@material-ui/icons";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import {IconButton} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {useUpdateAvailability} from "../availibilities/redux/availabilities.hook";
import {TimeForm} from "../../sharedComponents/TimeForm";

const useStyles = makeStyles(((theme) => ({
    timelineContentContainer: {
        position: 'relative',
        paddingLeft: theme.spacing(1),
        width: 280
    },
    availabilityHeadline: {
        display: 'inline-flex',
        alignItems: 'center'
    },
    editButton: {
        marginLeft: theme.spacing(1)
    }
})))

export const AvailabilityTimelineItem: FC<{ availability: FeAvailability, variant: 'from' | 'to' }> = ({
                                                                                                           availability,
                                                                                                           variant
                                                                                                       }) => {
    const classes = useStyles();

    const [showTimeForm, setShowTimeForm] = React.useState(false);

    const {updateAvailability} = useUpdateAvailability();

    const updateAvailabilityFrom = (from: number) => updateAvailability(availability.id, {from});
    const updateAvailabilityTo = (to: number) => updateAvailability(availability.id, {to});

    return (
        <TimelineItem>
            <TimelineOppositeContent>
                <Typography variant="body2" color="textSecondary">
                    {format(availability[variant], "HH:mm")}
                </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot color="primary">
                    <PlayArrow/>
                </TimelineDot>
                {variant === 'from' && <TimelineConnector/>}
            </TimelineSeparator>
            <TimelineContent>
                <div className={classes.timelineContentContainer}>
                    {showTimeForm
                        ? (
                            <TimeForm
                                initialValue={variant === 'from' ? availability.from : availability.to}
                                moreThan={variant === 'to' ? availability.from : undefined}
                               /* onSubmit={time => {console.log("time", time); return Promise.resolve()}}*/
                                onSubmit={variant === 'from' ? updateAvailabilityFrom: updateAvailabilityTo}
                                onClose={() => setShowTimeForm(false)}
                            />
                        )
                        : (
                            <React.Fragment>
                                <Typography
                                    variant="h6"
                                    component="h1"
                                    color="textSecondary"
                                    className={classes.availabilityHeadline}
                                >
                                    {variant === "from" ? "Start Verfügbarkeit" : "Ende Verfügbarkeit"}
                                    <IconButton size="small" className={classes.editButton}
                                                onClick={() => setShowTimeForm(true)}>
                                        <EditOutlined fontSize="inherit"/>
                                    </IconButton>
                                </Typography>
                            </React.Fragment>
                        )
                    }
                </div>
            </TimelineContent>
        </TimelineItem>
    )
}
